import { render } from "./EditScenario.vue?vue&type=template&id=55b10b6f&ts=true"
import script from "./EditScenario.vue?vue&type=script&lang=ts"
export * from "./EditScenario.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__